import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BreadcrumbActions } from "@ha/ui/navigation";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Actions, ofActionSuccessful, Select, Store } from "@ngxs/store";
import { Observable, take } from "rxjs";

import { NewsPage } from "../../models/news-page";
import { NewsStatus } from "../../models/news-status.enum";
import { NewsActions } from "../../states/news.actions";
import { NewsSelectors } from "../../states/news.selectors";

@UntilDestroy()
@Component({
    selector: "ntf-news",
    templateUrl: "news.component.html",
    styleUrls: ["news.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsComponent implements OnInit {
    @Select(NewsSelectors.currentNews)
    public news$!: Observable<NewsPage>;

    public newsId: number;

    public newsImage: string;

    constructor(
        private store: Store,
        private activatedRoute: ActivatedRoute,
        private actions$: Actions,
        private cd: ChangeDetectorRef,
    ) {}

    public ngOnInit(): void {
        this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((params) => {
            if (params["newsId"]) {
                this.newsId = parseInt(params["newsId"], 10);
                this.store.dispatch(new NewsActions.GetCurrentNews(this.newsId));
            }
        });

        this.actions$.pipe(ofActionSuccessful(NewsActions.GetCurrentNews)).pipe(untilDestroyed(this), take(1))
            .subscribe(() => {
                this.store.dispatch(new NewsActions.SetNewsStatus(this.newsId, NewsStatus.Read));

                this.store.dispatch(
                    new BreadcrumbActions.SetTextOrLangKey([{
                        text: this.store.selectSnapshot(NewsSelectors.currentNews)?.heading.value,
                    }]),
                );
            });

        this.actions$.pipe(ofActionSuccessful(NewsActions.GetAllNews)).pipe(untilDestroyed(this), take(1)).subscribe(
            () => {
                const allNews = this.store.selectSnapshot(NewsSelectors.news);
                if (allNews) {
                    const news = allNews.find((n) => n.contentId === this.newsId);
                    if (news) {
                        this.newsImage = news.newsImage;
                        this.cd.detectChanges();
                    }
                }
            },
        );
    }
}
